import ErrorRepository                     from "../../../domain/fundamentals/message/error/ErrorRepository";
import Errors                              from "../../../domain/fundamentals/message/error/Errors";
import { errorInitAction, errorSetAction } from "../../redux/error/ErrorAction";

class ErrorDataSource implements ErrorRepository {
  constructor(readonly dispatch) {}

  init(): void {
    this.dispatch(errorInitAction());
  }

  set(errors: Errors): void {
    this.dispatch(errorSetAction(errors));
  }

}

export default ErrorDataSource;